import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '@/lib/api';
import { useAuth } from '@/context/AuthContext';

export default function AuthCallback() {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        // Idempotency guard for StrictMode double-invocation.
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = window.location.hash || '';
        const match = hash.match(/session_id=([^&]+)/);
        if (!match) {
            navigate('/login', { replace: true });
            return;
        }
        const session_id = match[1];

        (async () => {
            try {
                const { data } = await api.post('/auth/session', { session_id });
                setUser(data.user);
                // Clean the hash and go to dashboard
                window.history.replaceState(null, '', '/dashboard');
                navigate('/dashboard', { replace: true, state: { user: data.user } });
            } catch (e) {
                navigate('/login', { replace: true });
            }
        })();
    }, [navigate, setUser]);

    return (
        <div className="min-h-screen flex items-center justify-center text-slate-500 text-sm">
            Finishing sign-in…
        </div>
    );
}
